import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import auth from '@/store/store-auth'
import cases from '@/store/store-cases'
import creditors from '@/store/store-creditors'
import files from '@/store/store-files'
import sources from '@/store/store-sources'
import tags from '@/store/store-tags'

// import watchStore from './watchers'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
    key: 'creditordesk',
    storage: window.localStorage,
    reducer: (state) => ({
        auth: {
            token: state.auth.token,
            rememberEmail: state.auth.rememberEmail,
            rememberedEmail: state.auth.rememberedEmail,
            hasAccount: state.auth.hasAccount,
        },
    }),
})

const vuexSessionStorage = new VuexPersist({
    key: 'creditordesk',
    storage: window.sessionStorage,
    reducer: (state) => ({
        
    }),
})

const Store = new Vuex.Store({
    modules: {
        auth,
        cases,
        creditors,
        files,
        sources,
        tags,
    },

    plugins: [
        vuexLocalStorage.plugin,
        vuexSessionStorage.plugin,
    ],
})

import '@/store'

export default Store

// watchStore(Store)
